import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { MdCall, MdAccessTime, MdOutlineEmail } from "react-icons/md";
import { Link, useHistory } from "react-router-dom";
import Labels from "../../services/apiLabels";
import { POST } from "../../constant/apiMethods";
import { CREATE_SUBSCRIPTION } from "../../constant";
import BrandLogo from "../../../components/BrandLogo/BrandLogo";
import "./style.css";

const trim = (str) => (str || "").trim();

export const Footer = ({
  create_subscription,
  subscriptionSuccessAt,
}) => {
  const history = useHistory();
  const [email, setemail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (subscriptionSuccessAt) {
      setemail("");
      setSubmitting(false);
    }
  }, [subscriptionSuccessAt]);

  const subscribe_me = (event) => {
    if (event) event.preventDefault();
    if (submitting) return;
    const nextEmail = email.trim();
    if (!nextEmail) return;
    setSubmitting(true);
    create_subscription({ email: nextEmail }, () => setSubmitting(false));
  };

  const tradeLinks = [
    { to: "/dealers/dashbord/buynow", label: "Buy now" },
    { to: "/dealers/dashbord/auction", label: "Auctions" },
    { to: "/dealers/showInterest", label: "Show interest" },
    { to: "/dealers/dashbord", label: "Dashboard" },
  ];

  const supportLinks = [
    { to: "/", label: "Home" },
    { to: "/dealers/aboutus", label: "About us" },
    { to: "/dealers/contactus", label: "Contact" },
    { to: "/dealers/faqs", label: "FAQs" },
  ];

  const legalLinks = [
    { to: "/dealers/privacypolicy", label: "Privacy Policy" },
    { to: "/dealers/terms", label: "Terms and conditions" },
    { to: "/dealers/requridocuments", label: "Required documents" },
  ];

  return (
    <div className="footer-v2 dealers-footer-v2">
      <div className="footer-v2__main">
        <div className="footer-v2__inner dealers-footer-v2__inner">
          <div className="footer-v2__grid dealers-footer-v2__grid">
            <div className="footer-v2__brand dealers-footer-v2__brand">
              <div className="dealers-footer-v2__brand-row">
                <BrandLogo
                  variant="light"
                  onClick={() => history.push("/dealers")}
                  className="footer-v2__logo"
                />
                <span className="dealers-footer-v2__badge">Dealers</span>
              </div>
              <h2 className="footer-v2__headline">
                Dealer support for the trade floor.
              </h2>
              <p className="footer-v2__desc">
                Questions on auctions, buy now, bidding, or sourcing? Reach the
                AutoTrade Port dealer desk.
              </p>
              <div className="footer-v2__contact">
                <a className="footer-v2__contact-item" href="tel:+923030303030">
                  <MdCall size={17} aria-hidden />
                  +92 303 0303030
                </a>
                <span className="footer-v2__contact-item">
                  <MdAccessTime size={17} aria-hidden />
                  11:30am – 07:30pm
                </span>
                <Link className="footer-v2__contact-item" to="/dealers/contactus">
                  <MdOutlineEmail size={17} aria-hidden />
                  Contact desk
                </Link>
              </div>
            </div>

            <nav className="footer-v2__col" aria-label="Trade floor">
              <h3 className="footer-v2__col-title">Trade floor</h3>
              <ul className="footer-v2__links">
                {tradeLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="footer-v2__link">
                      {trim(link.label)}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            <nav className="footer-v2__col" aria-label="Support">
              <h3 className="footer-v2__col-title">Support</h3>
              <ul className="footer-v2__links">
                {supportLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="footer-v2__link">
                      {trim(link.label)}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="footer-v2__newsletter footer-v2__newsletter--card dealers-footer-v2__newsletter">
              <h3 className="footer-v2__newsletter-title">Dealer alerts</h3>
              <p className="footer-v2__newsletter-desc">
                Auction openings, buy-now drops, and platform updates.
              </p>
              <form
                className="footer-v2__subscribe-form"
                onSubmit={subscribe_me}
              >
                <label
                  className="footer-v2__sr-only"
                  htmlFor="dealers-footer-subscribe-email"
                >
                  Email address
                </label>
                <div className="footer-v2__field">
                  <span className="footer-v2__field-icon" aria-hidden>
                    <MdOutlineEmail size={20} />
                  </span>
                  <input
                    id="dealers-footer-subscribe-email"
                    onChange={(e) => setemail(e.target.value)}
                    value={email}
                    className="footer-v2__input"
                    type="email"
                    required
                    placeholder="Dealer email"
                  />
                </div>
                <button
                  type="submit"
                  name="CTAButton"
                  className="footer-v2__submit"
                  disabled={submitting}
                >
                  {submitting ? "Subscribing…" : "Subscribe"}
                </button>
              </form>
              <nav className="dealers-footer-v2__legal" aria-label="Legal">
                {legalLinks.map((link) => (
                  <Link key={link.to} to={link.to}>
                    {trim(link.label)}
                  </Link>
                ))}
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  subscriptionSuccessAt: state.product?.subscriptionSuccessAt,
});

const mapDispatchToProps = (dispatch) => ({
  create_subscription: (data, callBack) =>
    dispatch({
      type: CREATE_SUBSCRIPTION,
      payload: {
        type: CREATE_SUBSCRIPTION,
        label: Labels.createSubscription,
        method: POST,
        data,
        hideOverlayLoader: true,
        callBack,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
